var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7605 2.08331C13.5314 2.08331 14.1668 2.71874 14.1668 3.48957V5.03122C14.1668 5.59372 13.8126 6.29165 13.4689 6.64582L10.4481 9.31248C10.0314 9.66665 9.7501 10.3646 9.7501 10.9271V13.9479C9.7501 14.3646 9.46887 14.9271 9.1147 15.1458L8.13553 15.7812C7.21886 16.3437 5.95842 15.7083 5.95842 14.5833V10.8646C5.95842 10.375 5.67719 9.73957 5.39594 9.38541L2.72928 6.57289C2.37511 6.21873 2.09388 5.59372 2.09388 5.16664V3.55207C2.08346 2.71873 2.71884 2.08331 3.48967 2.08331H12.7605Z",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9157 9.37499C22.9157 6.12499 22.1031 4.08332 20.2177 3.02082C19.6865 2.71873 18.624 2.48956 17.6553 2.33331",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0835 12.5V15.625C2.0835 20.8333 4.16683 22.9167 9.37516 22.9167H15.6252C20.8335 22.9167 22.9168 20.8333 22.9168 15.625V13.5417",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5415 13.5417H18.7498",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4585 17.7083H18.7502",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.70c66914dbd2e32170febc2b1bfeed90.svg";
export { ForwardRef as ReactComponent };